/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { useEffect } from 'react';

import { useEntityContext } from '../../../../util/entity-provider/context';
import { useCommandIntelligence } from '../../CommandIntelligenceContext';
import { DEFAULT_MAX_ATTACHED_ITEMS } from '../../constants';
import { useRegisterCommandIntelligence } from '../../useRegisterCommandIntelligence';

export const useCommandIntelligenceScreenHost = ({
  scopeId,
  commandIntelligenceConfig,
  renderContextBar,
  getItemKey,
  availableItems = [],
  enabled = true,
  maxAttachedItems = DEFAULT_MAX_ATTACHED_ITEMS,
}) => {
  const { entityRef } = useEntityContext();
  const { session, updateAvailableItems } = useCommandIntelligence();

  const isRegistrationEnabled = enabled !== false && Boolean(entityRef) && Boolean(scopeId);

  useRegisterCommandIntelligence({
    commandIntelligenceConfig,
    renderContextBar,
    getItemKey,
    maxAttachedItems,
    prefsScopeId: scopeId,
    enabled: isRegistrationEnabled,
  });

  useEffect(() => {
    if (!session?.open || !isRegistrationEnabled) {
      return;
    }

    updateAvailableItems?.(availableItems ?? []);
  }, [session?.open, isRegistrationEnabled, availableItems, updateAvailableItems]);
};
